import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68a3c3cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-desktop" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { style: {"margin":"0"} }
const _hoisted_5 = {
  class: "flex-desktop",
  style: {"justify-content":"end","align-items":"center"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { logIn, logOut, print, arrowBack } from "ionicons/icons";
import {
  IonContent,
  IonPage,
  IonRow,
  IonCol,
  IonItem,
  IonLabel,
  IonFooter,
  IonGrid,
  IonFab,
  IonFabButton,
  IonBadge,
  IonButton,
  IonLoading,
  IonIcon,
  onIonViewWillEnter,
  useIonRouter,
} from "@ionic/vue";
import { useContextStore } from "@/stores/context";
import { computed, reactive } from "vue";
import { useRoute } from "vue-router";
import { IVisitor } from "@/models/visitor";
import { getVisitorById } from "@/api/visitors";
import { pencil } from "ionicons/icons";
import {
  getSessionRegistrations,
  getSessions,
  sessionRegistration,
  updateSessionRegistration,
} from "@/api/sessions";
import { ISession, ISessionRegistration } from "@/models/session";
import { Printer, PrintOptions } from "@awesome-cordova-plugins/printer";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { FileOpener } from "@ionic-native/file-opener";
import axios from "axios";
import { getDefaultLabelPdf } from "@/api/label";
import { useUserStore } from "@/stores/user";
import { useToasters } from "@/composition/toasters";
import { handleError } from "@/views";
import { useWindowWidth } from "@/composition/window";
import { useAppStore } from "@/stores/app";


export default /*#__PURE__*/_defineComponent({
  __name: 'Visitor',
  setup(__props) {

const { isMobile } = useWindowWidth();
const contextStore = useContextStore();
const router = useIonRouter();
const toasters = useToasters();
const route = useRoute();
const appStore = useAppStore();

const state = reactive({
  visitor: {} as IVisitor,
  checkInRegistration: undefined as ISessionRegistration | undefined,
  loading: false,
});

const visitor_id = parseInt(route.params.visitor_id as string, 10);

let session = {} as ISession;

onIonViewWillEnter(() => {
  getVisitor();
});

const getVisitor = () => {
  state.loading = true;
  getVisitorById(visitor_id)
    .then((response) => {
      state.visitor = response.data;
      state.loading = false;
      getSessions({
        event: contextStore.event.id,
        search: "check-in",
      })
        .then((response) => {
          session = response.data.results[0];
          if (session) {
            getSessionRegistrations({
              event: contextStore.event.id,
              visitor: state.visitor.id,
              session: session.id,
            })
              .then((response) => {
                state.checkInRegistration = response.data.results[0];
                state.loading = false;
              })
              .catch(() => {
                state.loading = false;
              });
          }
        })
        .catch((err) => {
          handleError(err);
          state.loading = false;
        });
    })
    .catch((err) => {
      handleError(err);
      state.loading = false;
    });
};

const printTag = () => {
  state.loading = true;

  getDefaultLabelPdf({ event: contextStore.event.id })
    .then((response) => {
      const userStore = useUserStore();
      axios
        .get(
          `${response.data.url}?target_type=Attending&target_id=${visitor_id}&ci=true`,
          {
            headers: {
              // tslint:disable-next-line: object-literal-key-quotes
              Authorization: `Token ${userStore.token}`,
              "content-type": "application/pdf",
              "Accept-Language": "en",
            },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          Printer.isAvailable()
            .then(() => {
              const reader = new FileReader();
              reader.readAsDataURL(
                new Blob([response.data], { type: "application/pdf" })
              );
              reader.onloadend = function () {
                const base64data = reader.result as string;
                const filepath = `beamian-check-in_label--${Date.now()}.pdf`;
                Filesystem.writeFile({
                  path: filepath,
                  data: base64data,
                  directory: Directory.Documents,
                  // encoding: Encoding.UTF16,
                })
                  .then((result) => {
                    FileOpener.open(result.uri, "application/pdf")
                      .then(() => {
                        state.loading = false;
                      })
                      .catch(() => {
                        toasters.addWarning(
                          "Could not open file, attempting to print directly"
                        );
                        let options: PrintOptions = {
                          // orientation: "landscape",
                          monochrome: true,
                          margin: false,
                          autoFit: false,
                          paper: {
                            width: "62",
                            height: "30",
                            name: "Roll24Inch",
                            length: "62",
                          },
                        };
                        Printer.print(result.uri, options)
                          .then(
                            () => {
                              state.loading = false;
                            },
                            () => {
                              toasters.addError(
                                "Label printing failed, please try again."
                              );
                              state.loading = false;
                              Filesystem.deleteFile({
                                path: filepath,
                                directory: Directory.Documents,
                              });
                            }
                          )
                          .catch(() => {
                            state.loading = false;

                            toasters.addWarning("Document was not printed");
                            Filesystem.deleteFile({
                              path: filepath,
                              directory: Directory.Documents,
                            });
                          });
                      });
                  })
                  .catch(() => {
                    state.loading = false;
                    toasters.addError(
                      "Could not create local PDF file for printing"
                    );
                  });
              };
            })
            .catch(() => {
              state.loading = false;
              toasters.addError("Could not initialize printing");
            });
        })
        .catch((err) => {
          state.loading = false;
          handleError(err);
        });
    })
    .catch((err) => {
      state.loading = false;
      handleError(err);
    });
};

const checkOutVisitor = () => {
  state.loading = true;
  if (state.checkInRegistration) {
    updateSessionRegistration({
      ...state.checkInRegistration,
      status: 3,
    })
      .then((response) => {
        state.loading = false;
        toasters.addSuccess("Visitor checked out");
        state.checkInRegistration = {
          ...state.checkInRegistration,
          ...response.data,
        };
        getVisitor();
      })
      .catch((err) => {
        state.loading = false;

        if (err.response.data.detail) {
          toasters.addError(err.response.data.detail);
        } else if (err.response.data._errors) {
          err.response.data._errors.forEach((error: any) => {
            toasters.addError(error.message);
          });
        } else {
          toasters.addError(
            "Could not check-in visitor, please try again later."
          );
        }
      });
  }
};
const checkInVisitor = () => {
  state.loading = true;
  if (state.checkInRegistration) {
    updateSessionRegistration({
      ...state.checkInRegistration,
      status: 2,
    })
      .then((response) => {
        toasters.addSuccess("Visitor checked in");
        state.checkInRegistration = {
          ...state.checkInRegistration,
          ...response.data,
        };
        state.loading = false;
        getVisitor();
      })
      .catch((err) => {
        state.loading = false;

        if (err.response.data.detail) {
          toasters.addError(err.response.data.detail);
        } else if (err.response.data._errors) {
          err.response.data._errors.forEach((error: any) => {
            toasters.addError(error.message);
          });
        } else {
          toasters.addError(
            "Could not check-in visitor, please try again later."
          );
        }
      });
  } else if (state.visitor.id) {
    sessionRegistration({
      session: session.id,
      status: 1,
      attending: state.visitor.id,
    })
      .then((response) => {
        state.loading = false;

        toasters.addSuccess("Visitor checked in");
        state.checkInRegistration = response.data;
        getVisitor();
      })
      .catch((err) => {
        state.loading = false;

        if (err.response.data.detail) {
          toasters.addError(err.response.data.detail);
        } else if (err.response.data._errors) {
          err.response.data._errors.forEach((error: any) => {
            toasters.addError(error.message);
          });
        } else {
          toasters.addError(
            "Could not check-in visitor, please try again later."
          );
        }
      });
  }
};

const getCheckinStatus = (status_id: number) => {
  let status_description = "";

  switch (status_id) {
    case 1: {
      status_description = "Registered";
      break;
    }
    case 2: {
      status_description = "Entered";
      break;
    }
    case 3: {
      status_description = "Checked out";
      break;
    }
    default: {
      status_description = "Registered";
      break;
    }
  }

  return status_description;
};

const dark_mode = computed(() => appStore.settings.theme === "dark");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(dark_mode.value ? 'full-width' : 'colored-bg full-width')
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(IonGrid), { style: {"width":"calc(100% + 110px)"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonRow), {
                      style: _normalizeStyle(_unref(isMobile) ? '' : 'position: relative; right: 100px')
                    }, {
                      default: _withCtx(() => [
                        (!_unref(isMobile))
                          ? (_openBlock(), _createBlock(_unref(IonFabButton), {
                              key: 0,
                              class: "fab-visitor",
                              color: "primary",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), { icon: _unref(arrowBack) }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (state.visitor.profile_picture)
                          ? (_openBlock(), _createBlock(_unref(IonCol), {
                              key: 1,
                              size: "4"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("img", {
                                  src: state.visitor.profile_picture
                                }, null, 8, _hoisted_3)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(IonCol), null, {
                          default: _withCtx(() => [
                            _createElementVNode("h4", _hoisted_4, _toDisplayString(state.visitor.name), 1),
                            _createElementVNode("p", null, _toDisplayString(state.visitor.email), 1),
                            (state.visitor.checkin_status === 1)
                              ? (_openBlock(), _createBlock(_unref(IonBadge), {
                                  key: 0,
                                  color: "registered"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(getCheckinStatus(state.visitor.checkin_status)), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (state.visitor.checkin_status === 2)
                              ? (_openBlock(), _createBlock(_unref(IonBadge), {
                                  key: 1,
                                  color: "entered"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(getCheckinStatus(state.visitor.checkin_status)), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (state.visitor.checkin_status === 3)
                              ? (_openBlock(), _createBlock(_unref(IonBadge), {
                                  key: 2,
                                  color: "checkedout"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(getCheckinStatus(state.visitor.checkin_status)), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (!_unref(isMobile))
                          ? (_openBlock(), _createBlock(_unref(IonCol), { key: 2 }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_5, [
                                  _createElementVNode("div", null, [
                                    (
                          state.checkInRegistration &&
                          state.checkInRegistration.status === 2
                        )
                                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                                          key: 0,
                                          expand: "block",
                                          fill: "clear",
                                          color: "dark",
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (checkOutVisitor()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonIcon), {
                                              slot: "start",
                                              icon: _unref(logOut)
                                            }, null, 8, ["icon"]),
                                            _createTextVNode(" Check out ")
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_unref(IonButton), {
                                          key: 1,
                                          expand: "block",
                                          fill: "clear",
                                          color: "dark",
                                          onClick: _cache[2] || (_cache[2] = ($event: any) => (checkInVisitor()))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(IonIcon), {
                                              slot: "start",
                                              icon: _unref(logIn)
                                            }, null, 8, ["icon"]),
                                            _createTextVNode(" Check in ")
                                          ]),
                                          _: 1
                                        }))
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_unref(IonButton), {
                                      expand: "block",
                                      fill: "clear",
                                      color: "dark",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (printTag()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonIcon), {
                                          slot: "start",
                                          icon: _unref(print)
                                        }, null, 8, ["icon"]),
                                        _createTextVNode(" Print ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_unref(IonFabButton), {
                                      color: "primary",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonIcon), { icon: _unref(pencil) }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _hoisted_6
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["style"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Birthdate ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonLabel), { slot: "end" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(state.visitor.birthdate), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Job title ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonLabel), { slot: "end" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(state.visitor.job_title), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Company ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonLabel), { slot: "end" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(state.visitor.company), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Country ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonLabel), { slot: "end" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(state.visitor.country), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(" Phone number ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonLabel), { slot: "end" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(state.visitor.phone_number), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ], 2)
          ])
        ]),
        _: 1
      }),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonFab), {
            key: 0,
            vertical: "bottom",
            horizontal: "center",
            slot: "fixed",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (
        _unref(router).push(
          `/event/${_unref(contextStore).event.id}/edit-visitor/${state.visitor.id}`
        )
      ))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonFabButton), {
                color: "primary",
                id: "edit-visitor"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), { icon: _unref(pencil) }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(isMobile))
        ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonGrid), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRow), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          (
                state.checkInRegistration &&
                state.checkInRegistration.status === 2
              )
                            ? (_openBlock(), _createBlock(_unref(IonButton), {
                                key: 0,
                                expand: "block",
                                fill: "clear",
                                color: "dark",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (checkOutVisitor()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "start",
                                    icon: _unref(logOut)
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" Check out ")
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_unref(IonButton), {
                                key: 1,
                                expand: "block",
                                fill: "clear",
                                color: "dark",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (checkInVisitor()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), {
                                    slot: "start",
                                    icon: _unref(logIn)
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" Check in ")
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonCol), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            expand: "block",
                            fill: "clear",
                            color: "dark",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (printTag()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), {
                                slot: "start",
                                icon: _unref(print)
                              }, null, 8, ["icon"]),
                              _createTextVNode(" Print ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_unref(IonLoading), {
        "is-open": state.loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})